import { render, staticRenderFns } from "./coupon-order-info.vue?vue&type=template&id=71933478&scoped=true&"
import script from "./coupon-order-info.vue?vue&type=script&lang=js&"
export * from "./coupon-order-info.vue?vue&type=script&lang=js&"
import style0 from "./coupon-order-info.vue?vue&type=style&index=0&id=71933478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71933478",
  null
  
)

export default component.exports